import { render, staticRenderFns } from "./ChartjsScatterChart.vue?vue&type=template&id=fa614a84"
import script from "./ChartjsScatterChart.vue?vue&type=script&lang=js"
export * from "./ChartjsScatterChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports